import { render, staticRenderFns } from "./boxPage.vue?vue&type=template&id=802a1bc2&scoped=true"
import script from "./boxPage.vue?vue&type=script&lang=js"
export * from "./boxPage.vue?vue&type=script&lang=js"
import style0 from "./boxPage.vue?vue&type=style&index=0&id=802a1bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802a1bc2",
  null
  
)

export default component.exports